import React, { useEffect, useState } from 'react';
import Select from 'xpi-black-ui/Base/Select';
import { P } from 'xpi-black-ui/Base/Typography';
import Container, { Title, OperationTypeContainer, OrderByContainer, OrderByButton } from './styles';

export default function OperationOrderByMenu({
  operations,
  isOperationShelfType,
  quantityOnShelf,
  quantityOnExclusive,
  setOperationType,
  setOperationsOrderBy,
  disableOrder = false,
}) {
  const [orderBy, setOrderBy] = useState({ label: 'Papel', value: 'ativo.nome' });
  const [isOrderByAscending, setIsOrderByAscending] = useState(true);

  const OrderByAscending = () => (
    <svg width="28" height="16" viewBox="0 0 28 16" fill="none" cursor="pointer" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 7L12.59 8.41L8 3.83L8 16L6 16L6 3.83L1.41 8.42L-3.93402e-07 7L7 3.0598e-07L14 7Z" fill="#6D717A" />
      <rect x="16" y="2" width="12" height="2" fill="#6D717A" />
      <rect x="16" y="8" width="8" height="2" fill="#6D717A" />
      <rect x="16" y="14" width="4" height="2" fill="#6D717A" />
    </svg>
  );

  const OrderByDescending = () => (
    <svg width="28" height="16" viewBox="0 0 28 16" fill="none" cursor="pointer" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 9L12.59 7.59L8 12.17L8 -2.62268e-07L6 -3.49691e-07L6 12.17L1.41 7.58L-3.93402e-07 9L7 16L14 9Z" fill="#6D717A" />
      <rect x="16" y="2" width="12" height="2" fill="#6D717A" />
      <rect x="16" y="8" width="8" height="2" fill="#6D717A" />
      <rect x="16" y="14" width="4" height="2" fill="#6D717A" />
    </svg>
  );

  const orderByIsHighlight = operation => operation?.sort((a, b) => (a.isHighlight > b.isHighlight ? -1 : 1));

  const orderBySelection = () => {
    const ORDERNED_BY_ASSET_NAME = operations?.sort((a, b) => {
      const SELECTED_VALUE = orderBy.value.split('.');
      const HAS_TWO_OBJECT_PROPS = (SELECTED_VALUE.length === 2);
      const OBJECT_A = HAS_TWO_OBJECT_PROPS ? a[SELECTED_VALUE[0]][SELECTED_VALUE[1]].toString() : a[SELECTED_VALUE[0]].toString();
      const OBJECT_B = HAS_TWO_OBJECT_PROPS ? b[SELECTED_VALUE[0]][SELECTED_VALUE[1]].toString() : b[SELECTED_VALUE[0]].toString();

      return isOrderByAscending
        ? OBJECT_A.localeCompare(OBJECT_B)
        : OBJECT_B.localeCompare(OBJECT_A);
    });

    return orderByIsHighlight(ORDERNED_BY_ASSET_NAME);
  };

  /* useEffect(() => {
    if (operations.length > 0) {
      setOperationsOrderBy([...orderBySelection()])
    }
  }), [operations, orderBy, isOrderByAscending]; */

  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    if (operations?.length > 0) {
      setOperationsOrderBy([...orderBySelection()]);
    }
  }, [operations, orderBy, isOrderByAscending]);

  return (
    <Container>
      <OperationTypeContainer>
        <Title onClick={() => setOperationType('prateleira')} isActived={isOperationShelfType}>
          Prateleira ({quantityOnShelf})
        </Title>

        <Title onClick={() => setOperationType('exclusiva')} isActived={!isOperationShelfType}>
          Exclusivas ({quantityOnExclusive})
        </Title>
      </OperationTypeContainer>

      {!disableOrder && (
        <OrderByContainer>
          <P>Ordenar por:</P>
          <Select
            className="selectOrderBy"
            onChange={setOrderBy}
            options={[
              { label: 'Papel', value: 'ativo.nome' },
              { label: 'Estrutura', value: 'estrutura.nome' },
              { label: 'Comissão', value: 'pctComissao' },
              { label: 'Encerramento', value: 'vencimento' },
            ]}
            placeholder="Selecione a ordenação..."
            noOptionsMessage={() => 'Opção não encontrada'}
            value={orderBy}
          />

          {isOrderByAscending && <OrderByButton onClick={() => setIsOrderByAscending(false)}><OrderByAscending /></OrderByButton>}
          {!isOrderByAscending && <OrderByButton onClick={() => setIsOrderByAscending(true)}><OrderByDescending /></OrderByButton>}
        </OrderByContainer>
      )}
    </Container>
  );
}
